export const MAIN_CARDS = [
  {
    title: 'RS-lang',
    text: `
    Если вам интересны занимательные и веселые способы изучения и совершенствования английского языка, RS Lang идеально вам подойдет. 
    Наше приложение содержит различные подходы изучения слов в игровой форме. Неважно, какой у вас уровень английского -
    каждый сможет почерпнуть для себя что-то новое. RS Lang всегда под рукой, a удобный интерфейс адаптирован под любое устройство.
    И всё это бесплатно!`,
    advantages: [],
    name: 'advantages',
  },
  {
    title: 'Games',
    text: `Играй и учись! «Спринт» - расширяет словарный запас и помогает легко и весело повторять изученное.
    «Аудиовызов» - улучшает восприятие речи на слух и способствует коррекции акцента.`,
    advantages: [
      '6 уровней сложности для каждой игры',
      'Управление с клавиатуры',
      'Неограниченное количество повторов в "Аудиовызове"',
      'Сохрание игровой статистики для авторизованных пользователей',
    ],
    route: 'games',
  },
  {
    title: 'E-book',
    text: `Слова из коллекции всемирно известной серии учебников “4000 essential english words”. 
    Всё самое нужное и часто употребляемое в одном месте.
    Для начинающих, продолжающих и уже отчаявшихся выучить :)`,
    advantages: [
      '6 разделов, от более простых и известных к более сложным',
      'Иллюстрации, аудио и примеры употребления ',
      'Запускай игры с выбранным набором слов',
      'Добавляй сложные слова в отдельный раздел и повторяй их чаще',
    ],
    route: 'textbook',
  },
  {
    title: 'Statistics',
    text: `Следи за своим стремительным прогрессом! 
    Количество новых слов за день, результаты мини-игр, самая длинная серия правильных ответов - всё это доступно для авторизованных пользователей в нашем приложении.`,
    advantages: [
      'Графики новых слов',
      '“Аудиовызов”',
      '“Спринт”',
      'Долгосрочная статистика обучения',
    ],
    route: 'stats',
  },
  {
    title: 'About',
    text: `Три awesome developers на пути к деплою мечты!
    Баги, недосып, Redux, типизация всего живого и непрерывный рефакторинг. 
    Весь трудный трёхнедельный путь на одной странице.`,
    advantages: [
      'Фотографии участников',
      'Magic animation',
      'Красивые лэйблы с задачами',
      'Ссылки на GitHub (открыты для предложений :)',
    ],
    route: 'about',
  },
]

export const ADVANTAGES = [
  {
    title: 'Более 3500 слов',
    text: `В нашем учебнике более 3500 слов, они поделены на 6 категорий сложности. Зарегистрировавшись, вы сможете хранить самые сложные слова в своём личном словаре. И они всегда будут под рукой.`,
    name: 'advantage__words',
  },
  {
    title: 'Мини-игры',
    text: `Изучение слов ещё никогда не было столь увлекательным! С помощью мини-игр “Спринт” и “Аудиовызов” мы сделали процесс обучения еще более интересным.`,
    name: 'advantage__games',
  },
  {
    title: 'Статистика',
    text: `Следите за своим прогрессом каждый день. Для зарегистрированных пользователей доступна статистика из мини-игр и долгосрочные графики изученных слов.`,
    name: 'advantage__stats',
  },
]
